import { useTranslation } from 'react-i18next'
import { ChartColumn } from 'lucide-react'
import { EmptyState } from '@/components/common/States'
import { Page } from '@/components/layout/Page'
import { PageHeading } from '@/components/layout/PageHeading'

/** The analytics phase (P8) fills this page; until then it says so rather than rendering blank. */
export default function AnalyticsPage() {
  const { t } = useTranslation()
  return (
    <Page>
      <PageHeading description={t('analytics.eyebrow')} title={t('analytics.title')} />
      <div className="mt-6 rounded-lg border border-line bg-background">
        <EmptyState icon={ChartColumn} title={t('analytics.comingTitle')} message={t('analytics.coming')} />
      </div>
    </Page>
  )
}
